import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-daily-stock-report',
  templateUrl: './daily-stock-report.component.html',
  styleUrls: ['./daily-stock-report.component.scss']
})
export class DailyStockReportComponent implements OnInit {
  sale_date: any = null;
  title: any;
  data_loading = false;
  is_data_available = false;
  document_file = null;
  pdf_data: any = null;

  constructor(private globalService: GlobalService, private httpService: HttpService, private domSanitizer: DomSanitizer) {
    this.title = this.globalService._active_display_name;
  }

  serveDailyStock() {
    let data_dict = {
      'sale_date': this.sale_date
    };
    this.is_data_available = false;
    this.data_loading = true;
    this.httpService.serveDailyStockReport(data_dict).subscribe((data) => {
      this.data_loading = false;
      if(data['is_data_exists']){
        console.log(data);
        this.document_file = data;
        this.is_data_available = true;
        this.pdf_data = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      }
      else{
        this.is_data_available = false;
        alert('Data is not available')
        return false;

      }
    }, (error) => {
      this.is_data_available = false;
      this.data_loading = false;
      console.error(error);
    });
  }

  downloadClicked() {
    let linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    let file_name = this.document_file['file_name'];
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = file_name;
    downloadLink.click();
  }


  ngOnInit() {
  }

}
